import RefClient from 'ref-client-core';
import openChargingStations from './openChargingStations';
import traceFormatter from './trace';

RefClient.formatterPlugin.register('trace', traceFormatter);
RefClient.formatterPlugin.register(
  'openChargingStations',
  openChargingStations
);
